<h1>Firestore Notes</h1>
<p>This is a very basic demo of the Firestore database.</p>

<input [(ngModel)]="content" placeholder="Add your own note" class="input">


<button class="button is-success" (click)="createNote()" [disabled]="content?.length < 2 || content?.length > 200">
  Add Note
</button>
<hr>
<div *ngFor="let note of notes | async">
  <note-detail [note]="note"></note-detail>
</div>





// WEBPACK FOOTER //
// ./src/app/notes/notes-list/notes-list.component.html